import ApiClient from "../api-client.js";

export const SERVICE_NAME = "holidays";
const adminClient = new ApiClient({ servicePath: `admin/${SERVICE_NAME}` });

export const getHolidays = async ({
  tenantId,
  name = "",
  businessHoursId = null,
} = {}) => {
  const nameParam = name ? `&name=${name}` : "";
  const businessHoursIdParam = businessHoursId
    ? `&businessHoursId=${businessHoursId}`
    : "";

  const path = `?tenantId=${tenantId}` + nameParam + businessHoursIdParam;

  return await adminClient.get({ path });
};

export const createHoliday = async ({ body }) => {
  return await adminClient.post({ body });
};

export const editHoliday = async ({ id, body }) => {
  return await adminClient.patch({ path: `/${id}`, body });
};

export const deleteHoliday = async ({ id }) => {
  return await adminClient.delete({ path: `/${id}` });
};
